import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["onClick"]

import { computed, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import FilteringDataDisplay from '../components/FilteringDataDisplay.vue'
import FormOrderItem from '../components/FormOrderItem.vue'
import TableCellRender from '../components/TableCellRender.vue'
import BannerOffline from '../components/BannerOffline.vue'
import { useNetwork } from '../composables/useNetwork'
import { useTimers } from '../store/timers'
import FormInventoryView from '../components/FormInventoryView.vue'
import { useInventory } from '../store/useInventory'
import { storeToRefs } from 'pinia'
import RenderProductLines from '../components/inventory/RenderProductLines.vue'
import RenderPartImage from '../components/inventory/RenderPartImage.vue'

//translations

export default /*#__PURE__*/_defineComponent({
  __name: 'PageInventory',
  setup(__props) {

const { t } = useI18n({ useScope: 'global' })
const tablesLabel = (key: string) => t(`tables.${key}`)

//modal logic
const tab = ref('balance')
const modal = ref(false)
const currentModalData = ref()
const startModal = (data: any) => {
  modal.value = true
  currentModalData.value = data
}
const startImageModal = (data: any) => {
  itemModal.value = true
  currentModalData.value = data
}
const itemModal = ref(false)
/**
 * Balance
 * Table of active hardware inventory, so rep can add to balance
 */
const { getCurrentBalanceAsTable: balanceData, getAllParts: allItemsData } = storeToRefs(
  useInventory()
)
const { updateBalance, removeItemFromBalance } = useInventory()
const { storeActive, getActiveParentTimer } = storeToRefs(useTimers())
const adjustInvetoryReasonCodes = computed(() => [
  { reason_name: 'Cycle Count', name: 'cycleCount', show: true },
  { reason_name: 'Transfer', name: 'transfer', show: true },
  { reason_name: 'Damaged', name: 'damaged', show: true },
  // { reason_name: 'autoEquipmentImport', name: 'autoEquipmentImport' }, //do not use
  { reason_name: 'Recovered at Store', name: 'recoveredAtStore', show: storeActive.value },
  { reason_name: 'Others', name: 'others', show: true },
])
const adjustInventoryHeaders = computed((): { header: string; subheaders: [string, string] } => {
  return {
    header: 'Adjust Amount',
    subheaders: [`${currentModalData.value.description}`, `${currentModalData.value.quantity}`],
  }
})
const adjustInventoryItem = async (e: any) => {
  console.log(e)
  await updateBalance({
    id: e.data.id,
    quantity: e.quantity,
    originalQuantity: e.originalQuantity,
    date: e.date,
    reason: e.reason.name,
    reason_name: e.reason.reason_name,
    comment: e.comment ?? null,
    ...(e.toRep && { toRep: e.toRep.id }),
    ...(e.reason.name == 'recoveredAtStore' && { from: getActiveParentTimer.value!.data.store_id }),
  })
}
const removeInventoryItem = async (e: any) => {
  await removeItemFromBalance({ id: e.data.id })
}

const addInvetoryReasonCodes = computed(() => [
  { reason_name: 'Cycle Count', name: 'cycleCount', show: true },
  { reason_name: 'Recovered at Store', name: 'recoveredAtStore', show: storeActive.value },
  { reason_name: 'Others', name: 'others', show: true },
])

const addInventoryHeaders = computed((): { header: string; subheaders: [string, string] } => {
  return {
    header: 'Add Inventory Item',
    subheaders: [
      `${currentModalData.value.id}/${currentModalData.value.description}`,
      `${currentModalData.value.pl_short_name}/${currentModalData.value.pl_description}`,
    ],
  }
})
const { addItemToBalance } = useInventory()

const addInventoryItem = async (e: any) => {
  //
  await addItemToBalance({
    id: e.data.id,
    description: e.data.description,
    pl_short_name: e.data.pl_short_name,
    pl_description: e.data.pl_description,
    quantity: e.quantity,
    image: e.data.image,
    reason: e.reason.name,
    reason_name: e.reason.reason_name,
    comment: e.comment,
    ...(e.toRep && { toRep: e.toRep.id }),
    ...(e.reason.name == 'recoveredAtStore' && { from: getActiveParentTimer.value!.data.store_id }),
  })
}

/**
 * Connection logic
 */
const { getStatus } = useNetwork()

return (_ctx: any,_cache: any) => {
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _component_q_tab = _resolveComponent("q-tab")!
  const _component_q_tabs = _resolveComponent("q-tabs")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_tab_panel = _resolveComponent("q-tab-panel")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_tab_panels = _resolveComponent("q-tab-panels")!
  const _component_q_page = _resolveComponent("q-page")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(BannerOffline, { "data-test": "pageInventory" }, {
      default: _withCtx(() => [
        _createTextVNode(" You are offline, please connect in order to adjust inventory. ")
      ]),
      _: 1
    }),
    _createVNode(_component_q_page, { class: "q-pt-sm" }, {
      default: _withCtx(() => [
        _createVNode(_component_q_dialog, {
          modelValue: itemModal.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((itemModal).value = $event))
        }, {
          default: _withCtx(() => [
            _createVNode(FormInventoryView, {
              header: currentModalData.value['description'],
              image: currentModalData.value['image']
            }, null, 8, ["header", "image"])
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_q_tabs, {
          modelValue: tab.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((tab).value = $event)),
          class: "text-grey",
          "active-color": "secondary",
          "indicator-color": "secondary",
          align: "left",
          "narrow-indicator": ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_tab, {
              name: "balance",
              label: tablesLabel('balance')
            }, null, 8, ["label"]),
            _createVNode(_component_q_tab, {
              name: "allItems",
              label: tablesLabel('allItems')
            }, null, 8, ["label"])
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_q_separator),
        _createVNode(_component_q_tab_panels, {
          modelValue: tab.value,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((tab).value = $event)),
          animated: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_tab_panel, {
              "keep-alive": "",
              name: "balance"
            }, {
              default: _withCtx(() => [
                _createVNode(FilteringDataDisplay, { "table-data": _unref(balanceData) }, {
                  image: _withCtx((row) => [
                    (row.rowData.image)
                      ? (_openBlock(), _createBlock(RenderPartImage, {
                          key: 0,
                          onClick: ($event: any) => (startImageModal(row.rowData)),
                          "image-data": row.rowData.image,
                          "image-type": "thumbnail"
                        }, null, 8, ["onClick", "image-data"]))
                      : _createCommentVNode("", true)
                  ]),
                  description: _withCtx(({ rowData, filterData }) => [
                    _createVNode(TableCellRender, {
                      data: rowData['description'],
                      "data-type": "string",
                      filter: filterData
                    }, null, 8, ["data", "filter"])
                  ]),
                  pl_info: _withCtx(({ rowData }) => [
                    _createVNode(RenderProductLines, { "row-data": rowData }, null, 8, ["row-data"])
                  ]),
                  quantity: _withCtx(({ rowData }) => [
                    _createElementVNode("span", {
                      class: "text-primary underline cursor-pointer",
                      onClick: ($event: any) => (startModal(rowData))
                    }, _toDisplayString(rowData['quantity']), 9, _hoisted_1)
                  ]),
                  _: 1
                }, 8, ["table-data"]),
                (_unref(getStatus))
                  ? (_openBlock(), _createBlock(_component_q_dialog, {
                      key: 0,
                      modelValue: modal.value,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((modal).value = $event))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_card, null, {
                          default: _withCtx(() => [
                            _createVNode(FormOrderItem, {
                              "allow-zero": "",
                              data: currentModalData.value,
                              "render-order": ['reason', 'quantity', 'users', 'comment'],
                              "reason-options": adjustInvetoryReasonCodes.value,
                              headers: adjustInventoryHeaders.value,
                              labels: { action: 'adjust', quantity: 'newQuantity' },
                              "show-remove": "",
                              onAction: _cache[2] || (_cache[2] = ($event: any) => (adjustInventoryItem($event))),
                              onRemove: _cache[3] || (_cache[3] = ($event: any) => (removeInventoryItem($event)))
                            }, null, 8, ["data", "reason-options", "headers"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(_component_q_tab_panel, {
              "keep-alive": "",
              name: "allItems"
            }, {
              default: _withCtx(() => [
                _createVNode(FilteringDataDisplay, { "table-data": _unref(allItemsData) }, {
                  image: _withCtx((row) => [
                    (row.rowData.image)
                      ? (_openBlock(), _createBlock(RenderPartImage, {
                          key: 0,
                          onClick: ($event: any) => (startImageModal(row.rowData)),
                          "image-data": row.rowData.image,
                          "image-type": "thumbnail"
                        }, null, 8, ["onClick", "image-data"]))
                      : _createCommentVNode("", true)
                  ]),
                  pl_info: _withCtx(({ rowData }) => [
                    _createVNode(RenderProductLines, { "row-data": rowData }, null, 8, ["row-data"])
                  ]),
                  itemRight: _withCtx(({ rowData }) => [
                    _createVNode(_component_q_btn, {
                      onClick: ($event: any) => (startModal(rowData)),
                      round: "",
                      color: "secondary",
                      icon: "add",
                      size: "sm"
                    }, null, 8, ["onClick"])
                  ]),
                  _: 1
                }, 8, ["table-data"]),
                (_unref(getStatus))
                  ? (_openBlock(), _createBlock(_component_q_dialog, {
                      key: 0,
                      modelValue: modal.value,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((modal).value = $event))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_card, null, {
                          default: _withCtx(() => [
                            _createVNode(FormOrderItem, {
                              "allow-zero": "",
                              data: currentModalData.value,
                              "render-order": ['quantity', 'reason', 'comment'],
                              "reason-options": addInvetoryReasonCodes.value,
                              headers: addInventoryHeaders.value,
                              labels: { action: 'add', quantity: 'quantity' },
                              onAction: addInventoryItem
                            }, null, 8, ["data", "reason-options", "headers"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _: 1
    })
  ], 64))
}
}

})